import {useDispatch} from "react-redux";
import * as tutorialActions from "store/actions/tutorial";
import {showPopUp} from "components/PopUp";
import TwoButtonPopup from "components/PopUp/FillButtonPopup/TwoButton";
import View from "./View";

function Container({title, missions}) {
  const dispatch = useDispatch();

  function onClickCloseMenuBtn() {
    dispatch(tutorialActions.handleTutorialList());
  }

  function onClickMissionList(idx) {
    dispatch(tutorialActions.handleTutorialMission(idx));
    onClickCloseMenuBtn();
  }

  function onClickExit() {
    window.close();
  }

  function onClickExitTutorialBtn() {
    showPopUp(
      <TwoButtonPopup
        contents="여기까지만 하고 나갈까요?"
        confirmTextId="ID_POPUP_OUT"
        cancelTextId="ID_POPUP_KEEP"
        confirmAction={onClickExit}
      />,
      {
        defaultPadding: false,
      },
    );
  }

  return (
    <View
      title={title}
      missions={missions}
      onClickCloseMenuBtn={onClickCloseMenuBtn}
      onClickMissionList={onClickMissionList}
      onClickExitTutorialBtn={onClickExitTutorialBtn}
    />
  );
}

export default Container;
